import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private message: NzMessageService,
    private ngxLoader: NgxUiLoaderService,
  ) {}

  getEvents(page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.get(`${SETTINGS.CMS_API}/api/event`,{withCredentials: true}).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to retrieve events');
          reject(error);
        },
      );
    });
  }
  //
  getEventsById(id: string): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.get(`${SETTINGS.CMS_API}/api/event/${id}`,{withCredentials: true},).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to retrieve events');
          reject(error);
        },
      );
    });
  }

  getEventsBySearch(
    name: string,
    page: number,
    pageSize: number,
  ): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(`${SETTINGS.CMS_API}/api/event?where[name][contains]=${name}`,{withCredentials: true})
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve events');
            reject(error);
          },
        );
    });
  }

  getAcceptedEventsByUser(id: string): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(`${SETTINGS.CMS_API}/api/event?where[accepted][contains]=${id}`,{withCredentials: true})
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve events');
            reject(error);
          },
        );
    });
  }

  getRejectedEventsByUser(id: string): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(`${SETTINGS.CMS_API}/api/event?where[rejected][contains]=${id}`,{withCredentials: true})
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve events');
            reject(error);
          },
        );
    });
  }

  getInvitedEventsByUser(id: string): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(`${SETTINGS.CMS_API}/api/event?where[member][contains]=${id}`,{withCredentials: true})
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve events');
            reject(error);
          },
        );
    });
  }

  getEventsByStartDate(): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(`${SETTINGS.CMS_API}/api/event?sort=startTime&limit=100`,{withCredentials: true})
        .subscribe(
          (response: any) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            console.error('Error fetching events:', error);
            // Don't show error message, just resolve with empty array
            resolve({ docs: [] });
          },
        );
    });
  }

  updateEvent(eventId: any, eventData: any): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .patch(`${SETTINGS.CMS_API}/api/event/${eventId}`,eventData,{withCredentials: true})
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create(
              'error',
              'Failed to Update Registration Status',
            );
            reject(error);
          },
        );
    });
  }

  getEventsByDate(payload: any): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .post(`${SETTINGS.CMS_API}/api/event/get-by-date`, payload,{withCredentials: true})
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve events');
            reject(error);
          },
        );
    });
  }
}
